import { object } from "../helpers/object";
import { debug } from "../helpers/debug";
import { responsive } from "../helpers/responsive";
import { utils } from "../helpers/utils";
import { stack } from "../helpers/stack";
import { throttle } from "throttle-debounce";


/*------------------------------------*\
  #HEADER
\*------------------------------------*/
class Header {

  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
    this.headerHeight = this.getHeight();
    this.scroll = {
      direction: 'UP',
      position: 0,
      gap: 0
    }
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;

    // RESPONSIVE
    this.responsiveHandler();
    // SCROLL EVENT HANDLER
    document.addEventListener('scroll', this.scrollHandler);
    stack.create('Header', this.DOM_MODULE[0], 'top');

    if(debug.DEBUG) console.log('modules/header.js');
  }

  /**
   * RESPONSIVE
   * 
   * Gestion de la maj du component
   * en fonction du media query
   */
  responsiveHandler = () => {
    document.addEventListener('RESPONSIVE_HAS_CHANGED', (event) => {
      this.headerHeight = this.getHeight();
      this.scrollHandler();
    });
  }
  isScrollUp = () => {
    const scrollDirection = utils.scrollDirection();
    const isScrollUp = scrollDirection === 'UP';
    if (this.scroll.direction !== scrollDirection) this.scroll.gap = 0;
    this.scroll.gap = this.scroll.gap + (window.scrollY - this.scroll.position);
    this.scroll.position = window.scrollY;
    this.scroll.direction = scrollDirection;
    
    return isScrollUp && Math.abs(this.scroll.gap) > 200 || !isScrollUp && Math.abs(this.scroll.gap) < 10;
  }
  /**
   * SCROLL HANDLER
   * @param {event} event 
   */
  scrollHandler = throttle(500,(event) => {
    if (responsive.is('lg')) {
      const isScrollUp = this.isScrollUp();
      const isSticky = (window.scrollY > this.headerHeight) ? 'sticky' : 'inherit';
      const isStickyVisible = (isSticky === 'sticky' && isScrollUp);
      
      this.DOM_MODULE[0].setAttribute('data-js-header', isSticky);
      this.DOM_MODULE[0].setAttribute('data-js-header-visible', isStickyVisible);
      stack.set('Header', 'top', isStickyVisible || isSticky === 'inherit')
    } else {
      stack.set('Header', 'top', true);
    }
  });
  getHeight = () => {
    return parseFloat(window.getComputedStyle(document.body).getPropertyValue('--header-height')) * parseFloat(getComputedStyle(document.documentElement).fontSize);
  }
  
}
export const header = new Header('[data-js-header]'); 